<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <div class="modal-window-header ">
      <div class="modal-window-heading">
        <h3 class="icon-heading small">{{ heading }}</h3>
      </div>
    </div>

    <div class="modal-window-body gray">
      <pre>{{ text }}</pre>
    </div>

    <div class="modal-window-footer">
      <div class="grid-x">
        <div class="cell auto" v-if="item.bruker">
          <span class="avatar black" :class="strToAvatarClass(item.bruker.initials)">{{item.bruker.initials}}</span>
          <div class="dl-wrap">
            <span class="dl dt" v-if="item.Tabell === 'objektOppgaveEmail'">Sendt av</span>
            <span class="dl dt" v-else-if="item.Tabell === 'kundeEmail'">Sendt av</span>
            <span class="dl dt" v-else-if="item.Endring === 'ukInsert'">Opprettet av</span>
            <span class="dl dt" v-else-if="item.Endring === 'ukModify'">Endret av</span>
            <span class="dl dt" v-else-if="item.Endring === 'ukDelete'">Slettet av</span>
            <span class="dl dd">{{item.bruker.full_name}}</span>
          </div>
        </div>
        <div class="cell auto" v-else>
          <span class="avatar black" :class="strToAvatarClass('-')">-</span>
          <div class="dl-wrap">
            <span class="dl dt" v-if="item.Tabell === 'objektOppgaveEmail'">Sendt av</span>
            <span class="dl dt" v-else-if="item.Tabell === 'kundeEmail'">Sendt av</span>
            <span class="dl dt" v-else-if="item.Endring === 'ukInsert'">Opprettet av</span>
            <span class="dl dt" v-else-if="item.Endring === 'ukModify'">Endret av</span>
            <span class="dl dt" v-else-if="item.Endring === 'ukDelete'">Slettet av</span>
            <span class="dl dd">Ikke tillgjengelig</span>
          </div>
        </div>

        <div class="cell shrink"><span class="text-small opacity-60">{{item.Dato | avantidate}}</span></div>
      </div>
    </div>

    <a href="javascript:;" class="modal-close modal-window-close-button" @click="$emit('close')">
      <span>Lukk</span>
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
    </a>
  </overlay-scrollbars>
</template>

<script>
export default {
  name: 'HistoryItemModal',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    heading: function () {
      let retval = ''

      let name = this._.toLower(this.item.Tabell)
      let type = this.item.Endring

      if (type === 'ukModify') {
        retval = 'endret'
      } else if (type === 'ukDelete') {
        retval = 'slettet'
      } else {
        retval = 'opprettet'
      }

      if (name === 'objektoppgaveemail') {
        return 'Usolgt objekt, e-post sendt til selger'
      } else if (name === 'kundeemail') {
        return 'E-post sendt til kunde'
      } else if (name === 'objekt') {
        return 'Objekt ' + retval
      } else if (name === 'kontrakt') {
        return 'Kontrakt ' + retval
      } else {
        return 'Kunde ' + retval
      }
    },
    text: function () {
      if (this.item.Logg) {
        let text = this._.trimEnd(this.item.Logg.replace(/Hbversion ?:[^,]+,/ig, ''))

        return this._.trim(text, ',') + '\n\n\n'
      }

      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/HistoryItemModal.vue